import { render, staticRenderFns } from "./FinanceForm.vue?vue&type=template&id=67272dfa&scoped=true"
import script from "./FinanceForm.vue?vue&type=script&lang=js"
export * from "./FinanceForm.vue?vue&type=script&lang=js"
import style0 from "./FinanceForm.vue?vue&type=style&index=0&id=67272dfa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67272dfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67272dfa')) {
      api.createRecord('67272dfa', component.options)
    } else {
      api.reload('67272dfa', component.options)
    }
    module.hot.accept("./FinanceForm.vue?vue&type=template&id=67272dfa&scoped=true", function () {
      api.rerender('67272dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/customer/onboarding/FinanceForm.vue"
export default component.exports